import {INTEGRATION_CODE_MONDAY} from '../../../../common/constants';
import {MondayLogo, MondaySmallLogo} from './MondayLogo';

export default {
  code: INTEGRATION_CODE_MONDAY,
  logo: MondayLogo,
  small_logo: MondaySmallLogo,
  redirect_uri: '/onboarding'
};
